<div class="card card-primary card-outline style">
    <div class="card-body box-profile">
      
    <!----
   <p class="style1">
        <b>ssss</b>
      </p>
      --->
      <div class="table-responsive">
  
        <div *ngFor="let c of output">
        <table class="table style">
        <tbody>
        <tr>
        <th style="width:30%">Date And Time:</th>
        <td>{{DateFormat(c.date_time)}}</td>
        </tr>
  
        <tr>
        <th>Manufacturer Id:</th>
        <td>{{c.manufacturer_id}}</td>
        </tr>

        <tr>
        <th>Recipient:</th>
        <td>{{c.recipient}}</td>
        </tr>

        <tr>
        <th>Write Off From:</th>
        <td>{{c.write_Off_from}}</td>
        </tr>
  
        <tr>
        <th>Entity:</th>
        <td>{{c.entity}}</td>
        </tr>
  
        <tr>
        <th>Transaction Type:</th>
        <td>{{c.transaction_type}}</td>
        </tr>
  
        <tr>
        <th>Status:</th>
        <td>{{c.status}}</td>
        </tr>
  
        </tbody></table>
  
      
            <p class="style2">
                <b>Products :</b>
                 </p>
              
                 <div class="card">
                  <div class="space" *ngFor="let d of c.products">
                 
                    <strong class="distance1">Item Name:</strong>{{d.item_name}}<br>
                    <strong class="distance2">UOM:&nbsp;&nbsp;&nbsp;&nbsp;</strong>{{d.uom_name}}<br>
                    <strong class="distance3">Quantity:</strong>{{d.quantity}}
                    <hr>
                  </div>
                
              
                  <p class="style2">
                    <b>Inventory :</b>
                     </p>
                  
                     <div class="card">
                      <div class="space" *ngFor="let d of c.inventory">
                        <strong class="distance1">Item Name:</strong>{{d.item_name}}<br>
                        <strong class="distance2">UOM:&nbsp;&nbsp;&nbsp;&nbsp;</strong>{{d.uom_name}}<br>
                        <strong class="distance3">Quantity:</strong>{{d.quantity}}
                        <hr>
                     

